import z from "zod";

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .nonempty("Email is required.")
    .email("Invalid email address.")
    .trim(),
});

export type ForgotPasswordSchema = z.infer<typeof forgotPasswordSchema>;
